<template>
  <div id="model-tree" class="w-full h-full">
    <div>
      <el-input
        size="small"
        placeholder="请输入要过滤的设备"
        v-model="filterTreeKeyWords"
        @keypress.native.enter="filterModelTree(0, true, filterTreeKeyWords, 0)"
        clearable
      >
        <el-button
          slot="append"
          icon="el-icon-arrow-down"
          class=""
          @click="filterModelTree(modelTreeProp.currentNodeItem, true, filterTreeKeyWords, 0)"
        ></el-button>
        <el-button
          slot="append"
          icon="el-icon-arrow-up"
          @click="filterModelTree(modelTreeProp.currentNodeItem, false, filterTreeKeyWords, 0)"
        ></el-button>
      </el-input>
    </div>
    <div class="w-full h-[calc(100%-40px)]" v-loading="!modelTreeProp.modelTreeLoadEnd">
      <el-tree
        class="modelTree bg-transparent overflow-auto h-full common-tree"
        v-if="modelTreeVisbile && modelTreeProp.modelTreeLoadEnd"
        :props="treeProps"
        ref="modelTree"
        :load="loadNode"
        highlight-current
        :lazy="true"
        show-checkbox
        :filter-node-method="filterNode"
        :default-checked-keys="modelTreeProp.defaultCheckedKey"
        :default-expanded-keys="defaultExpandedKeys"
        @node-click="clickModelTree"
        @check="checkModelTree"
        node-key="item"
      ></el-tree>
    </div>
  </div>
</template>

<script>
import { ActivityVisualApi } from '@wiz-api/haiguang'
import setModelVisible from '../../assets/js/model/modelTree'
import cloudRender from '../../assets/js/model/index'
import HandoverService from '../../service/HandoverService'

const activityVisual = new ActivityVisualApi()

export default {
  name: 'ModelTree',
  props: {
    player: {
      type: Object,
      default: null,
    },
    customProps: {
      type: Object,
      defalut: () => {
        return {
          modelTreeProp: {
            currentNodeItem: 0, // 当前激活的node
            currentNodeName: '', // 点选时当前激活的节点名称
            treeData: [], // 模型树数据
            defaultCheckedKey: [], // 模型树选中的节点
            filterItem: [], // 模型树不需要显示的节点及他的父节点列表
            modelHideList: [], // 模型隐藏队列
            modelTreeLoadEnd: false, // 模型树数据加载完毕
            spaceSwapStatus: false, // 交换空间状态
          },
        }
      },
    },
    loadModelStatus: {
      type: Boolean,
      default: false,
    },
    sourceId: {
      type: String,
      defalut: '',
    },
    modelTreeProp: {
      type: Object,
      default: () => {
        return {
          currentNodeItem: 0, // 当前激活的node
          currentNodeName: '', // 点选时当前激活的节点名称
          treeData: [], // 模型树数据
          defaultCheckedKey: [], // 模型树选中的节点
          filterItem: [], // 模型树不需要显示的节点及他的父节点列表
          modelHideList: [], // 模型隐藏队列
          modelTreeLoadEnd: false, // 模型树数据加载完毕
          spaceSwapStatus: false, // 交换空间状态
        }
      },
    },
    // 模型点选的节点node
    modelNode: {
      type: Object,
      default: () => {},
    },
    labelList: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  watch: {
    modelNode: {
      handler(node) {
        console.log('modelNode change', node)
        if (node?.name) {
          if (!node.name.toLowerCase().startsWith('Unspecified'.toLowerCase())) {
            this.currentNodeName = node.name
            this.filterModelTree(0, true, node.name, 3)
          }
        }
      },
      immediate: true,
    },
    'customProps.modelTreeProp.currentNodeName': {
      deep: true,
      handler(val, oldVal) {
        if (val) {
          this.currentNodeName = val
          this.filterModelTree(0, true, val, 3)
        }
      },
    },
    'customProps.modelTreeProp.defaultCheckedKey': {
      deep: true,
      handler(val, oldVal) {
        this.modelTreeVisbile = false
        this.modelTreeVisbile = true
        this.$nextTick(() => {
          if (this.$refs.modelTree) {
            this.$refs.modelTree.setCheckedKeys(this.modelTreeProp.defaultCheckedKey)
          }
        })
      },
    },
    'customProps.loadModelStatus': {
      immediate: true,
      async handler(val) {
        if (val) {
          this.getModelTreeDatas()
        }
      },
    },
  },
  async mounted() {
    await this.getStandardList()
    if (this.modelTreeProp.currentNodeName) {
      // 页面初始化时不定位模型
      this.filterModelTree(0, true, this.modelTreeProp.currentNodeName, 0, false)
    }
  },
  data() {
    return {
      standardId: '',
      modelTreeVisbile: true, // 模型树的显示
      filterTreeKeyWords: '', // 过滤模型树关键字
      defaultExpandedKeys: [], // 展开节点
      treeProps: {
        label: 'name',
        children: 'children',
        isLeaf: 'leaf',
      },
      currentNode: null, // 查询到模型树节点
      currentNodeName: '', // 点选时当前激活的节点名称
      modelTreeObj: {
        ITEM_PR: 0, // PR 文件节点类型
        ITEM_NODE: 1, // CELLNode文件节点类型
        ITEM_GISOBJ: 2, // gis 数据对象
        ITEM_NULL: 3, // 仅仅对根节点使用
      },
    }
  },
  methods: {
    async getStandardList() {
      const [err, res] = await HandoverService.getStandardList()
      if (!err && res && res.code === 0 && res.data) {
        this.standardId = res.data[0].id
      } else {
        this.standardId = ''
      }
    },
    // 模型树点击操作
    async clickModelTree(data, node, doLocation) {
      // 孤立查看
      const toolShowSingleItem = sessionStorage.getItem('ToolShowSingleItem')
      const temp = _.cloneDeep(this.modelTreeProp)
      temp.spaceSwapStatus && (temp.spaceSwapStatus = false)
      if (
        toolShowSingleItem &&
        toolShowSingleItem !== data?.item &&
        sessionStorage.getItem('ToolShowSingle') === 'false'
      ) {
        setModelVisible(this.player, 'system.ToolShowSingle', true, data, temp)
      }
      this.$emit('doLocation', {
        ...data,
        from: 'modelTree',
      })
      if (node && node.checked && doLocation) {
        this.multipleLocations(this.player, data)
        // 判断是否勾选任务信息标签再选择是否弹窗任务信息的弹窗
        if (
          this.labelList.find((val) => {
            return val.code === 'TaskInfo'
          }) &&
          this.labelList.find((val) => {
            return val.code === 'TaskInfo'
          }).checked
        ) {
          this.getVisualData(this.sourceId, data.code)
        }
        this.modelTreeProp.currentNodeItem = data && data.item ? data.item : 0 // 储存选中节点的item
      }
      this.locationNode(data.item)
      const [err, res] = await HandoverService.getInfo({
        code: data.code,
        standardId: this.standardId,
      })
      if (!err) {
        this.$emit('transferEvent', {
          toCom: { code: 'ObjectInfoDyw', origin: 'HandoverObjectDyw', name: '对象信息' },
          type: 'business',
          props: data.code
            ? {
              ...res.data[0],
              standardId: this.standardId,
              openAlarmFlicker: true,
              flickerFrequency: 500,
            }
            : {
              standardId: this.standardId,
              openAlarmFlicker: true,
              flickerFrequency: 500,
              code: data.code,
            },
        })
      }
    },
    async multipleLocations(player, data, isSelect = true, isLoadEngine) {
      // 高亮选中的模型
      if (isSelect) {
        player.Native.ModelTree.setSelectItemNoEvent(data.item)
      }
      // 计算获取到模型树item的aabb
      const result = await PlayerUtils.call(player.Native.ModelTree.calcItemAabbData, data.item)
      // 判断是否打开地球
      const isGis = await PlayerUtils.call(player.Native.GisPlatform.isGisMode)
      if (!isGis) {
        // 如果未打开地球，则用常规定位方式
        const aabbtmp = [result.aabb[0], result.aabb[1]]
        player.Native.Camera.moveToAabbWithFace(aabbtmp, isLoadEngine ? 0 : 2, isLoadEngine ? 1 : 0)
      } else {
        // 打开地球，需要考虑到模型的地形攀爬，防止摄像机定位过去之后位置在地面以下
        let bFind = false // 是否查找到具有gisTransform的祖先item
        let isChild = false // 当前点击的item是否是具有gisTransform item的子
        let toAabb = [] // 将要用来做最终定位的aabb
        let fItem = data.item // while 向上查询的临时变量
        while (fItem !== 0) {
          const iteminfos = await player.Native.ModelTree.getItemInfo(fItem)
          // gisTransform属性只能从节点对象中获取，因此，如果这里节点对象为0，则表明该item肯定不含有gisTransform
          if (!iteminfos.nodePtr || iteminfos.nodePtr === 0) {
            fItem = iteminfos.parentItem
            isChild = true
            continue
          }
          const nodeGisPos = await PlayerUtils.call(
            player.Native.NodeProxy.nodeGisPos,
            iteminfos.nodePtr
          )
          // 获取加载模型时设置的gisPos(即个isTransform信息)，如果该pos为空数组，表示当前item不含有gisTransform属性
          if (!nodeGisPos.length) {
            fItem = iteminfos.parentItem
            isChild = true
            continue
          }
          // 获取到了gisPos， 用gisPos中的经纬度查询实际高程
          const realH = await PlayerUtils.call(player.Native.GisPlatform.queryDEM, [
            [nodeGisPos[0], nodeGisPos[1]],
          ])
          // 使用查询到的高程与gisPos组成经纬高构造 gisTransform矩阵
          const realGisTransform = await player.Native.GisPlatform.makeGisTransform([
            nodeGisPos[0],
            nodeGisPos[1],
            realH[0],
          ])
          // 使用 gisTransform矩阵变换 模型对象的localAabb，从而得到实际需要定位的aabb
          toAabb[0] = result.localAabb[0]
          toAabb[1] = result.localAabb[1]

          toAabb = await player.Native.Camera.transformAabb(toAabb, realGisTransform)
          bFind = true
          break
        }
        // 这里判断相机朝向是否需要改变，通过from和to两个位置的up向量的夹角大于一定门限来判断
        let faceIndex = 1
        // ##########################
        const camCurParam = await player.Native.Camera.currentParam()
        let v0 = camCurParam.eye
        let v1 = Vec3.multiplyScalar(Vec3.add(result.aabb[0], result.aabb[1]), 0.5)
        v0 = Vec3.normalize(v0)
        v1 = Vec3.normalize(v1)
        const angle = Vec3.angleBetween(v0, v1)
        // 如果夹角小于 1.5° ，则摄像机不用改变视角，只需要平移到目标包围盒
        if (angle < 1.5) {
          faceIndex = 0
        }
        // 执行定位
        if (bFind) {
          // ##############################
          player.Native.Camera.moveToAabbWithFace(toAabb, 2, faceIndex)
        } else {
          const aabbtmp = [result.aabb[0], result.aabb[1]]
          // ##############################
          player.Native.Camera.moveToAabbWithFace(aabbtmp, 2, faceIndex)
        }
      }
    },
    // 获取项目计划可视化数据
    async getVisualData(sceneId, tagCode) {
      const [err, res] = await activityVisual.getActivityVisual({
        tenantId:
          localStorage.getItem('CurrentTenantId') ||
          JSON.parse(localStorage.getItem('CurrentUser'))?.TenantId ||
          '8b53295c-b059-4caf-8fc6-4a1d9e7807e9',
        sceneId,
        tagCode,
      })
      // console.log(res, '获取项目计划可视化数据')
      if (!err) {
        if (!res.length) {
          this.$message.warning('该模型未配置关联任务')
        }
        const openEvent = new CustomEvent('openComponent', {
          detail: {
            toCom: { code: 'TaskInfo', origin: 'tag', originTagName: 'TaskInfo', name: '任务详情' },
            type: 'tags',
            props: {
              taskRow: res,
            },
          },
        })
        window.dispatchEvent(openEvent)
      }
    },
    // 模型树加载
    async loadNode(node, resolve) {
      let tempFilterKeys = _.filter(this.modelTreeProp.treeData, (el) => {
        return this.modelTreeProp.filterItem.indexOf(el.item) === -1
      })
      if (node.level === 0) {
        this.modelTreeProp.defaultCheckedKey = _.map(tempFilterKeys, (val) => {
          return val.item
        })
        return resolve(this.modelTreeProp.treeData)
      }
      const res = await cloudRender.Node.findItemChild(this.player, node.data.item)
      const filterRes = _.filter(res.data, (el) => {
        return el?.name && el?.visible
      })
      // 控制模型树的选中按钮
      tempFilterKeys = _.filter(filterRes, (el) => {
        return this.modelTreeProp.filterItem.indexOf(el.item) === -1
      })
      const tempCheckedKey = _.map(tempFilterKeys, (val) => {
        return val.item
      })
      // 过滤勾选状态为选中的子集
      const checkedKeys = _.map(
        _.filter(filterRes, (res4) => {
          return res4.checked
        }),
        (res5) => {
          return res5.item
        }
      )
      // 查看当前节点是否没有在隐藏队列
      // 保存this指向
      const _this = this
      const isNoFindModelHides = (nodeObj) => {
        return (
          _.indexOf(
            _.map(_this.modelTreeProp.modelHideList, (res1) => {
              return res1.item
            }),
            nodeObj.data.item
          ) === -1
        )
      }
      if (isNoFindModelHides(node)) {
        // 没有在隐藏队列中
        let node1 = node
        while (node1.level !== 0) {
          // 向上查找没有在隐藏队列的父辈节点
          if (isNoFindModelHides(node1)) {
            node1 = node1.parent
          } else {
            // 父级在隐藏队列就结束向上查找
            break
          }
        }
        if (node1.level === 0) {
          // 如果查找到跟节点都没有在隐藏队列中，那么就代表全是勾选状态，不存在半选
          this.modelTreeProp.defaultCheckedKey = [
            ...this.modelTreeProp.defaultCheckedKey,
            ...tempCheckedKey,
          ]
        } else if (_.some(filterRes, { checked: false })) {
          // 中间父级可能是半选或者空白
          // 通过父获取子集的状态,如果子集中有一个为false，那么就把父级从默认选中框中去除掉，然后在设置子集节点状态
          this.modelTreeProp.defaultCheckedKey = [
            ..._.filter(this.modelTreeProp.defaultCheckedKey, (val) => {
              return val !== node.data.item
            }),
            ...checkedKeys,
          ]
        }
      } else {
        // 在隐藏队列表
        this.modelTreeProp.defaultCheckedKey = [
          ...this.modelTreeProp.defaultCheckedKey,
          ...checkedKeys,
        ]
      }
      resolve(filterRes)
      _.forEach(filterRes, (el) => {
        if (this.currentNode && this.currentNode.item) {
          if (el.item === this.currentNode.item) {
            this.locationNode(this.currentNode.item)
          }
        }
      })
      if (this.modelTreeProp.defaultCheckedKey) {
        this.modelTreeVisbile = false
        this.modelTreeVisbile = true
        this.$nextTick(() => {
          if (this.$refs.modelTree) {
            this.$refs.modelTree.setCheckedKeys(this.modelTreeProp.defaultCheckedKey)
          }
        })
      }
    },
    locationNode(id) {
      this.$nextTick(() => {
        this.$refs.modelTree.setCurrentKey(id)
        setTimeout(() => {
          const node = document.getElementsByClassName('modelTree')[0]
          const currentNode = document.getElementsByClassName('is-current')[0]
          node.scrollTo({
            top: currentNode.offsetTop,
          })
        }, 600)
      })
    },
    checkModelTree(data, checkeds) {
      // 节点选中状态发生变化
      const isChecked = _.includes(checkeds.checkedKeys, data.item)
      setModelVisible(this.player, 'checkModelTree', isChecked, data, this.modelTreeProp, checkeds)
    },
    async filterModelTree(startItem, direction, KeyWords, type, doLocation = true) {
      // 过滤模型树
      // #######################
      this.currentNode = await PlayerUtils.call(
        this.player.Native.ModelTree.findItemByName,
        KeyWords, // 关键字
        startItem, // 开始查询的树节点
        direction, // 遍历方向
        type // 0 包含text子串,1 以text开头,2 以text结尾,3 与text相等
      )
      // 展开树
      if (!_.isEmpty(this.currentNode)) {
        await this.expendNode(this.currentNode, doLocation)
      } else {
        // 未找到
        this.$message({
          showClose: true,
          message: '搜索结果到底了',
          type: 'error',
        })
      }
    },
    // 展开节点树
    async expendNode(node, doLocation) {
      // item: 1为pr模型跟， node.parentItem = 0为杆塔模型的跟
      if (node.item === 1 || node.parentItem === 0) {
        // 到达根节点 执行点击事件
        this.$nextTick(() => {
          if (!this.currentNodeName) {
            // 无激活节点时
            this.clickModelTree(this.currentNode, { checked: this.currentNode.checked }, doLocation)
          }
          // 有选中激活节点时
          this.currentNodeName = ''
          this.locationNode(this.currentNode.item)
        })
      } else {
        const res = await PlayerUtils.call(
          this.player.Native.ModelTree.getItemInfo,
          node.parentItem
        )
        await this.expendNode(res)
        // 展开
        this.defaultExpandedKeys.push(res.item)
      }
    },
    filterNode(value, data) {
      if (!value) return true
      if (value === 'NotCode') return false
      return data.name.indexOf(value) !== -1
    },
    // 获取模型树数据
    async getModelTreeDatas() {
      // 加载模型完成后获取模型数据
      this.modelTreeProp.treeData = await PlayerUtils.call(
        this.player.Native.ModelTree.getRootItems
      )
      console.log('this.modelTreeProp.treeData', this.modelTreeProp.treeData)
      // 删除地球GIS层
      this.modelTreeProp.treeData = _.filter(this.modelTreeProp.treeData, (item) => {
        return (
          item.itemType === this.modelTreeObj.ITEM_PR ||
          item.itemType === this.modelTreeObj.ITEM_NODE
        )
      })
      this.modelTreeProp.modelTreeLoadEnd = true
    },
  },
}
</script>

<style lang="scss" scoped>
#model-tree {
  background-color: transparent;
}
::v-deep .el-loading-mask {
  height: calc(100% - 42px);
  background-color: rgba(0, 0, 0, 0.5) !important;
}
</style>
